import type { ProductArea, ReleaseItem, UpcomingItem, UpdateKind } from '@manaro/contracts'

export const kindFilters = ['Все', 'Новое', 'Улучшения', 'Исправления'] as const
export type KindFilter = (typeof kindFilters)[number]

export const areaFilters = ['Все', 'Сайт', 'CRM', 'Приложение', 'Админка'] as const
export type AreaFilter = (typeof areaFilters)[number]

const KIND_BY_FILTER: Record<Exclude<KindFilter, 'Все'>, UpdateKind> = {
  Новое: 'Новое',
  Улучшения: 'Улучшение',
  Исправления: 'Исправление',
}

export const matchesKind = (item: ReleaseItem, filter: KindFilter): boolean =>
  filter === 'Все' || item.kind === KIND_BY_FILTER[filter]

export const matchesArea = (item: { areas: ProductArea[] }, filter: AreaFilter): boolean =>
  filter === 'Все' || item.areas.includes(filter as ProductArea)

export function filterReleases(items: ReleaseItem[], kind: KindFilter, area: AreaFilter): ReleaseItem[] {
  return items.filter((item) => matchesKind(item, kind) && matchesArea(item, area))
}

export function filterUpcoming(items: UpcomingItem[], area: AreaFilter): UpcomingItem[] {
  return items.filter((item) => matchesArea(item, area))
}
